import * as React from 'react';
import { Button, Card, CardContent, CardHeader, EmailContentFrame } from '@repo/ui-web';

type CardState = 'default' | 'highlight';

const cardStates: CardState[] = ['default', 'highlight'];

const cardLabels: Record<CardState, string> = {
  default: 'Default',
  highlight: 'Highlight',
};

const sampleEmailHtml = `<div style="font-family: sans-serif; padding: 16px;">
  <h2 style="margin: 0 0 8px;">Welcome aboard!</h2>
  <p style="color: #555; margin: 0;">Thanks for joining. We're excited to have you on the team.</p>
</div>`;

export function CardShowcase() {
  const [state, setState] = React.useState<CardState>('default');

  return (
    <div className="space-y-8">
      <div className="space-y-4">
        <div className="flex flex-wrap gap-2">
          {cardStates.map((item) => (
            <Button
              key={item}
              type="button"
              size="md"
              variant={state === item ? 'default' : 'outline'}
              onClick={() => setState(item)}
            >
              {cardLabels[item]}
            </Button>
          ))}
        </div>
        <Card variant={state}>
          <CardHeader>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">
              Usage snapshot
            </p>
            <h4 className="text-lg font-semibold text-foreground">Weekly activity</h4>
          </CardHeader>
          <CardContent className="space-y-3">
            <p className="text-sm text-muted-foreground">
              Track how teams engage with the design system across products.
            </p>
            <Button size="md" variant="outline" type="button">
              View details
            </Button>
          </CardContent>
        </Card>
      </div>

      <div className="space-y-2">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">
          EmailContentFrame
        </p>
        <EmailContentFrame html={sampleEmailHtml} title="Sample email" />
      </div>
    </div>
  );
}
